<template>
  <v-dialog
    v-if="showDialog"
    :model-value="copyDialog"
    max-width="600"
    @click:outside="cleanUpAndCloseDialog"
  >
    <v-card>
      <v-card-title class="pt-4"
        >Copy </v-card-title
      >

      <v-card-text class="pt-0 pl-4">
        Do you want to copy the phreatic line to the phreatic reference line?

      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :loading="copyLoading"
          color="primary"
          text
          :disabled="copyLoading"
          @click="onCopy"
        >
          Copy
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "PhreaticLineCopyDialog",
  computed: {
    ...mapState("phreaticLine", {
      phreaticLineCoordinates: (state) => state.coordinates,
    }),
    ...mapState("phreaticReferenceLine", {
      copyDialog: (state) => state.copyDialog,
      copyLoading: (state) => state.copyLoading,
    }),
    showDialog() {
      return this.phreaticLineCoordinates.length > 0;
    },
  },
  methods: {
    ...mapActions("phreaticReferenceLine", {
      toggleCopyDialog: "toggleCopyDialog",
      copy: "copy",
    }),
    async onCopy() {
      try {
        await this.copy();
        this.$emit("copyClick");
        await this.toggleCopyDialog();
      } catch (e) {
        console.log(e);
      }
    },
    async cleanUpAndCloseDialog() {
      await this.toggleCopyDialog();
    },
  },
};
</script>
